import { Navigate, Outlet, useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import MobileBlockerScreen from '#globalComponents/MobileBlockerScreen/MobileBlockerScreen';
import { useAuth } from '#globalContexts/AuthProvider';
import { useCapabilityCheck } from '#globalHooks/useCapabilityCheck';
import useIsMobile from '#globalHooks/useIsMobile';

export default function ProtectedRoute({ required }) {
	const { user, loading: authLoading } = useAuth();
	const { hasCapability, isLoading: capLoading } = useCapabilityCheck(required);
	const location = useLocation();
	const isMobile = useIsMobile();

	if (authLoading || capLoading) return null;

	if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
	if (!hasCapability) return <Navigate to="/not-allowed" replace />;

	if (isMobile) return <MobileBlockerScreen />;

	return <Outlet />;
}

ProtectedRoute.propTypes = {
	required: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};
